exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#track_show[data-v-a065aef4]{padding-top:50px;padding-bottom:80px}", ""]);

// exports
